module.exports = __webpack_public_path__ + "images/modern-5-ee6f42b0f839e073ee382f6fc7fb4e62.jpg";